<file-manager [initialPath]="initialPath" [featureKey]="'MANAGEMENT_FILE_MANAGER'"></file-manager>

